"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.DeliveryBox = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _CourierBox = require("../CourierSelection/CourierBox");
var _Skeleton = require("../Skeleton");
var _AdditionalInfo = require("./AdditionalInfo");
var _AddressWrapper = require("./AddressWrapper");
var _DeleteButton = require("./DeleteButton");
var _StockInfo = require("./StockInfo");
var _styles = require("./styles");
var _useDeliveryItem = require("./useDeliveryItem");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const CourierSelection = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../CourierSelection/CourierSelection'))));
const DeliveryBox = (props)=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { activateDeliveryItem, addressAndCourierWrapperProps, addressWrapperProps, className, courier, courierName, courierSelectionProps, deliveryItem, hintMessages, isActive, isAdditionalInfoVisible, isAddressDeletable, isBoundCourierVisible, isButtonConfirmationEnabled, isCourierSelection, isFilteredHomeAddress, isHomeDelivery, isInvalid, isPickupShippingOfferVisible, isPrimaryAddress, isDisplayedInMainPage, onDeleteAddressClick, onShippingOfferBannerClick, ownerState, testId } = (0, _useDeliveryItem.useDeliveryItem)(props);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        ...getTestIdProps(testId),
        className: className,
        ownerState: ownerState,
        "aria-checked": isActive,
        "data-courier-name": courierName,
        role: "checkbox",
        children: [
            isButtonConfirmationEnabled ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Indicator, {
                ownerState: ownerState,
                ...getTestIdProps(_models.TestId.DeliveryBoxIndicator),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CheckHeavyIcon, {})
            }),
            Boolean(isAddressDeletable) && !isDisplayedInMainPage && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeleteButton.DeleteButton, {
                onClick: onDeleteAddressClick
            }),
            isInvalid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DeliveryMessage, {
                variant: "overline",
                children: formatMessage('notSupportedForDelivery')
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ...addressAndCourierWrapperProps,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.AddressBoxWrapper, {
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddressWrapper.AddressWrapper, {
                                ...addressWrapperProps
                            }),
                            !isInvalid && !isFilteredHomeAddress && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_StockInfo.StockInfo, {
                                isHomeDelivery: isHomeDelivery,
                                ...deliveryItem
                            }),
                            isAdditionalInfoVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AdditionalInfo.AdditionalInfo, {
                                isDisplayedInMainPage: isDisplayedInMainPage,
                                ...deliveryItem
                            }) : null,
                            Boolean(isButtonConfirmationEnabled) && isActive ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ConfirmButtonArea, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                                    fullWidth: true,
                                    maxWidth: "500px",
                                    variant: "contained",
                                    color: "primary",
                                    onClick: activateDeliveryItem,
                                    children: formatMessage('confirm')
                                })
                            }) : null
                        ]
                    }),
                    isPrimaryAddress && !isBoundCourierVisible && !isDisplayedInMainPage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.PrimaryAddressMessage, {
                        variant: "overline",
                        children: formatMessage('myPrimaryAddress')
                    }) : null,
                    isBoundCourierVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CourierBox.CourierBox, {
                        isBoundCourier: true,
                        courier: courier
                    }) : null
                ]
            }),
            !isCourierSelection && isActive ? hintMessages.map((message)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.PickupHintMessage, {
                    message: message
                }, message)) : null,
            isPickupShippingOfferVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.PickupShippingOffer, {
                onClick: onShippingOfferBannerClick
            }) : null,
            isCourierSelection ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Skeleton.CourierBoxSkeleton, {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CourierSelection, {
                    ...courierSelectionProps
                })
            }) : null
        ]
    });
};
exports.DeliveryBox = DeliveryBox;
var _default = exports.default = DeliveryBox;
